import NotificationPanelList from "./NotificationPanelList";

export default NotificationPanelList